module.exports = __webpack_public_path__ + "static/media/java.a7fd72b8.png";